import {FriendlyCaptchaSDK} from '@friendlycaptcha/sdk';

export default function frcCaptcha() {
    const sdk = new FriendlyCaptchaSDK();
    const forms = document.querySelectorAll('.js-frc-captcha-form');

    forms.forEach((form) => {
        const {sitekey} = form.dataset;
        const mount = form.querySelector('.js-frc-captcha-input');

        sdk.createWidget({
            element: mount,
            sitekey,
        });
    });
}
